import { defineMessages } from 'react-intl';

export default defineMessages({
    activationFailedTitle: {
        id: 'agent.registration.activation.Activation Failed Title',
        defaultMessage: 'Invalid Activation'
    },
    activationFailedBody: {
        id: 'agent.registration.activation.Activation Failed Body',
        defaultMessage: 'The information you entered does not match our records. Please try again.'
    },
    activationTitleTwia : {
        id: 'agent.registration.activation.Title.Twia',
        defaultMessage: 'TWIA Agent Registration'
    },
    activationTitleTfpa : {
        id: 'agent.registration.activation.Title.Tfpa',
        defaultMessage: 'TFPA Agent Registration'
    },
    activationLockoutBody: {
        id: 'agent.registration.activation.Activation Lockout Body',
        defaultMessage: 'You have exceeded the maximum number of allowed attempts. Please try again after 10 minutes.'
    },    
    newRegistrationLink: {
        id: 'agent.registration.activation.New Registration Link',
        defaultMessage: 'here'
    }    
});
